import { submitEvent, submitMove, submitMerge } from '@otto-ec/tracking-bct'
import { EventTypes, TrackingPort } from '../ports'
import { LoggingServicePort, LogLabelsParam } from '@otto-ec/eprivacy-shared'

export class TrackingBctAdapter<Labels extends Record<string, [string]>>
  implements TrackingPort<Labels>
{
  constructor(private readonly logger: LoggingServicePort) {}

  async track(eventName: EventTypes, labels: Labels): Promise<void> {
    try {
      switch (eventName) {
        case EventTypes.PageImpression:
          return await submitMerge<Labels>(labels)
        case EventTypes.Event:
          return await submitEvent<Labels>(labels)
        case EventTypes.Move:
          return await submitMove<Labels>(labels)
      }
    } catch (e) {
      this.logTrackingError(eventName, labels, e)
      return
    }
  }

  private logTrackingError(eventName: EventTypes, labels: Labels, e: unknown) {
    const eMessage = e instanceof Error ? e.message : new Error(String(e))
    const entriesWithError = [
      ...Object.entries(labels).map(([key, value]) => [key, value[0]] as const),
      ['errorMessage', eMessage.toString()] as const,
    ]
    const labelsWithError: LogLabelsParam = Object.fromEntries(entriesWithError)

    this.logger.info(`Error tracking event ${eventName}.`, labelsWithError)
  }
}
